import React, { useState } from 'react';
import { Card, Col, Row, Tabs } from 'antd';
import InstallerSearchMapLeafletForm from './installer-search-map-leaflet-form';
import InstallerSearchForm from './installer-search-form';
import { Content } from 'antd/lib/layout/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import Installer from '../../../classes/installer';
import { useTranslation } from 'react-i18next';

const { TabPane } = Tabs;

interface IProps {
    data: Installer;
    installerFun: (installer: Installer) => void;
    formIsValid: (isValid: boolean, values?: any) => void;
    nextStep: () => void;
}

const InstallerForm = (props: IProps) => {
    const { t } = useTranslation();
    const [installerContent, setInstallerContent] = useState<string>('1');

    const RenderInstallerSelection = (id: any) => {
        switch (id) {
            case '1':
                return <InstallerSearchMapLeafletForm data={props.data} installerSel={props.installerFun} />;
            case '2':
                return <InstallerSearchForm data={props.data} installerSel={props.installerFun} />;
        }
    };

    return (
        <Content>
            <h2 className="font-weight-600 title-content center">{t('sicuri&protetti.titles.title4B')}</h2>
            <Row style={{ padding: 5, textAlign: 'center' }} gutter={{ xs: 18, sm: 18, md: 18, lg: 32, xl: 32, xxl: 32 }}>
                {props.data.installerId === undefined ? <Col xs={{ span: 0 }} lg={{ span: 3 }} className="gutter-row"></Col> : ''}
                <Col xs={{ span: 24 }} lg={{ span: 18 }} className="gutter-row principal-row">
                    <Tabs defaultActiveKey={installerContent} onChange={(content: string) => setInstallerContent(content)}>
                        <TabPane
                            tab={
                                <div>
                                    <FontAwesomeIcon icon={faMapMarkedAlt} title={t('commonClass.map')} /> {t('commonClass.map')}
                                </div>
                            }
                            key="1"
                        >
                            {installerContent === '1' ? RenderInstallerSelection('1') : ''}
                        </TabPane>
                        <TabPane
                            tab={
                                <div>
                                    <FontAwesomeIcon icon={faListAlt} title={t('commonClass.list')} /> {t('commonClass.list')}
                                </div>
                            }
                            key="2"
                        >
                            {installerContent === '2' ? RenderInstallerSelection('2') : ''}{' '}
                        </TabPane>
                    </Tabs>
                </Col>
                {props.data.installerId !== undefined ? (
                    <Col xs={{ span: 24 }} lg={{ span: 6 }} style={{ paddingLeft: 5, paddingTop: 46 }} className="gutter-row">
                        <Card title={t('commonClass.selInstaller')}>
                            <div className="left">
                                <p>
                                    <strong>{t('customerClass.businessName')}</strong> : {props.data.businessName}
                                </p>
                                <p>
                                    <strong>{t('customerClass.address')}</strong> : {props.data.address}
                                </p>
                                <p>
                                    <strong>{t('commonClass.contactDetails')}</strong>
                                </p>
                                <p>{props.data.contacts}</p>
                                <br />
                                <p>
                                    <a
                                        href={'https://www.google.com/maps?q=?' + props.data.businessName! + props.data.address}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {t('commonClass.findOnGoogleMaps')}
                                    </a>
                                </p>
                            </div>
                        </Card>
                    </Col>
                ) : (
                    ''
                )}
            </Row>
        </Content>
    );
};

export default InstallerForm;
